import React, { useState } from "react";
import AddNewUser from "./AddNewUser";
import { useSession } from "../layout/SessionContext";

const Header = () => {
  const { hasPermission } = useSession();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleNewUser = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="md:px-6">
      <div className="flex justify-between items-center ">
        <h1 className="font-bold text-text1 whitespace-nowrap text-[24px] sm:text-[26px] md:text-[30px]">Manage users</h1>
        {hasPermission("Manage users", "edit") && (
        <button className="secondary_button text-xs sm:text-sm h-8 sm:h-10 px-3 sm:px-4 flex items-center justify-center" onClick={handleNewUser}>
          Add new
        </button>
        )}
      </div>
      <hr className=" border-gray-300 mt-6" />

      {/* Modal */}
      {isModalOpen && <AddNewUser closeModal={closeModal} />}
    </div>
  );
};

export default Header;
